<app-card icon="group" title="Agent Information" subtitle="Sales and passenger performance by agent" iconGradient="from-indigo-500 to-purple-600" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button [data]="exportData()" [excelTitle]="'agent-information'" [columns]="cols"></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="agentInformationData() || []"
        [loading]="loading()"
    ></app-table-component>
</app-card>

<ng-template #agentCellTemplate let-rowData="rowData">
    <div class="agent-cell">
        <span class="mini-avatar">{{ getInitials(rowData.agentName) }}</span>
        <strong>{{ rowData.agentName }}</strong>
    </div>
</ng-template>

<ng-template #airlineBadgeTemplate let-rowData="rowData">
    <span class="airline-badge">{{ rowData.topSellerAirline }}</span>
</ng-template>

<ng-template #paxChipTemplate let-rowData="rowData">
    <span class="pax-chip">{{ rowData.totalPax }}</span>
</ng-template>

<ng-template #priceColumnTemplate let-rowData="rowData">
    <span class="money">{{ rowData.revenue.amount | currency: rowData.revenue.currency }}</span>
</ng-template>
